"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Person = void 0;
var cloudinary_grayscale_photo_url_1 = require("../../utils/cloudinary-grayscale-photo-url");
var current_user_can_1 = require("../../utils/current-user-can");
var components_1 = require("../../components");
var entity_select_transform_1 = require("../../utils/entity-select-transform");
var graphql_1 = require("../../utils/graphql");
var utils_1 = require("@shapeable/utils");
exports.Person = {
  name: 'Person',
  label: 'Person',
  isPublic: true,
  groupName: 'Community',
  useMembership: true,
  useConnections: true,
  useSites: true,
  // useNetwork: true,
  useConversation: true,
  useDuplicateCheck: true,
  includeInSearch: true,
  usePermissions: true,
  useVisibility: true,
  canEmbed: true,
  useRoundedImage: true,
  useSlices: true,
  /*
  
    sections: [
      // by default, all sections exist in main
      {
         }
      {
        name: 'Places',
        column: 'aside',
        fields: ['locations', 'states', 'economies']
      },
         {
         }
       ]
    Example Person Config
    =====================
         main: [
        {
          label: '',
          fieldOrder: ['bio', 'platformObjective']
        },
        {
          
        }
      ]
      aside: {
        places: {
           }
      }
  */
  select: {
    optionBadge: function (option) {
      return option.entity && option.entity.hasAccount && 'member';
    },
    transform: function (entity, context) {
      return __assign(__assign({}, (0, entity_select_transform_1.entitySelectTransform)(entity, context)), {
        subLabel: entity.organisation && entity.organisation.name || entity.location && entity.location.name,
        badge: entity.hasAccount ? 'member' : '',
        tall: true,
        round: true,
        hasAccount: entity.hasAccount
      });
    },
    queryFields: "hasAccount photo { id url thumbnails { large { url } } } organisation { id name slug } location { id name slug }"
  },
  create: {
    label: 'Add %s'
  },
  // connections: {
  //   useGroups: true,
  //   dagLevelDistance: 1,
  // },
  autoRoutes: ['update', 'create', 'list', 'details'],
  pluralLabel: 'People',
  components: {
    card: components_1.PersonCard,
    cell: components_1.PersonCell,
    details: components_1.PersonDetailsLayout,
    image: components_1.PersonImage,
    banner: components_1.PersonDetailsBanner
  },
  export: {
    queryFields: (0, utils_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      email\n      organisation { name }\n      photo { url }\n      locations { name }\n      bio { text }\n      slug\n      latitude longitude\n      createdBy { name }\n      challengeExpertise {  challenges { name } levelOfExpertise { name } }\n      keyIssueExpertise { keyIssues { name } levelOfExpertise { name } }\n      trendExpertise { trends { name } levelOfExpertise { name } }\n      topicExpertise { topics { name } levelOfExpertise { name } }\n      subTopicExpertise { subTopics { name } levelOfExpertise { name } }\n      sdgExpertise { sdgs { name } levelOfExpertise { name } }\n      positions { position organisation { name } }\n      teamRoles { team { name } role { name } }\n      user { invited lastLogin loginCount }\n\n\n    "], ["\n      email\n      organisation { name }\n      photo { url }\n      locations { name }\n      bio { text }\n      slug\n      latitude longitude\n      createdBy { name }\n      challengeExpertise {  challenges { name } levelOfExpertise { name } }\n      keyIssueExpertise { keyIssues { name } levelOfExpertise { name } }\n      trendExpertise { trends { name } levelOfExpertise { name } }\n      topicExpertise { topics { name } levelOfExpertise { name } }\n      subTopicExpertise { subTopics { name } levelOfExpertise { name } }\n      sdgExpertise { sdgs { name } levelOfExpertise { name } }\n      positions { position organisation { name } }\n      teamRoles { team { name } role { name } }\n      user { invited lastLogin loginCount }\n\n\n    "])))
  },
  list: {
    applyVisibilityState: true,
    banner: {
      content: 'Get to know the people who are part of our network'
    },
    hasSearch: true,
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ...EntityValueFields\n      slug\n      position \n      isMember \n      hasAccount \n      sites {\n        ...EntityValueFields\n      }\n      organisation { \n        ...EntityValueFields\n        location { \n          id name slug state { id name abbr } \n          openGraph { id image { id url } } \n          country { id name slug shorthand } \n        } \n      } \n      openGraph { id image { id url } } \n      photo { id url thumbnails { id full { id url width height } } } location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      role { id name }\n      feedEntries { id }\n      chapterRoles { id }\n      positions { id }\n      teamRoles { id }\n      bio { id text plainTruncated: plain(truncate: { words: 60 }) }\n    "], ["\n      ...EntityValueFields\n      slug\n      position \n      isMember \n      hasAccount \n      sites {\n        ...EntityValueFields\n      }\n      organisation { \n        ...EntityValueFields\n        location { \n          id name slug state { id name abbr } \n          openGraph { id image { id url } } \n          country { id name slug shorthand } \n        } \n      } \n      openGraph { id image { id url } } \n      photo { id url thumbnails { id full { id url width height } } } location { id name slug state { id name abbr } openGraph { id image { id url } } country { id name slug shorthand } }\n      role { id name }\n      feedEntries { id }\n      chapterRoles { id }\n      positions { id }\n      teamRoles { id }\n      bio { id text plainTruncated: plain(truncate: { words: 60 }) }\n    "])))
  },
  filters: {
    fields: {
      country: {
        entityTypeName: 'Economy'
      },
      positionNames: {
        entityTypeName: 'Position'
      },
      keyIssues: {
        entityTypeName: 'KeyIssue'
      },
      challenges: {
        entityTypeName: 'Challenge'
      },
      topics: {
        entityTypeName: 'Topic'
      },
      expertiseLevels: {
        entityTypeName: 'ExpertiseLevel'
      }
    }
  },
  form: {
    modal: {
      fill: true
    },
    transformInput: function (_a) {
      return __awaiter(void 0, [_a], void 0, function (_b) {
        var input = _b.input;
        return __generator(this, function (_c) {
          // TODO - MAKE THIS GENERIC
          // This function transforms the array of 'EntityTypeName:id' strings coming out of the InputEntityReference component
          // into a serialized JSON for the mutation
          return [2 /*return*/, __assign(__assign({}, input), {
            pins: JSON.stringify((input.pins || []).map(function (id) {
              return {
                id: id
              };
            }))
          })];
        });
      });
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'contact'
    }, {
      name: 'roles'
    }, {
      name: 'places'
    }, {
      name: 'expertise',
      label: 'Expertise & Interest'
    }, {
      name: 'programs',
      label: 'Programs'
    }, {
      name: 'following'
    }],
    fields: {
      id: {
        type: 'id'
      },
      name: {
        type: 'name',
        description: "What is this Person's name?"
      },
      photo: {
        type: 'image',
        description: 'Upload or link to a photo. A square photo (equal height and width) is preferred.',
        fieldSet: 'overview',
        onDeriveUrl: cloudinary_grayscale_photo_url_1.cloudinaryCroppedPhotoUrl
      },
      bio: {
        type: 'longText',
        height: '80px',
        description: 'Please provide a summary of career and achievements for this {{PERSON}}.'
      },
      // pins: { type: 'entityReferenceMultiple', recommended: false, description: 'Specify items to pin to the landing page for this {{PERSON}}', label: 'Pins (Deprecated)', fieldSet: 'admin' },
      types: {
        type: 'linkedMultiple',
        entityTypeName: 'ProfileType',
        label: 'Profile Types',
        fieldSet: 'overview',
        description: "What type of profile is this?"
      },
      courseRegistrations: {
        type: 'linkedTable',
        isVisible: function () {
          return (0, current_user_can_1.currentUserCanAdmin)();
        },
        entityTypeName: 'CourseRegistration',
        label: 'Course Registrations',
        fieldSet: 'programs',
        description: 'Which {{COURSES}} is this {{PERSON}} registered against?'
      },
      platformObjective: {
        type: 'longText',
        height: '80px',
        description: 'Please describe the reasons why this {{PERSON}} is part of the platform and what they can offer to the network'
      },
      objectives: {
        type: 'linkedMultiple',
        entityTypeName: 'Objective',
        label: 'Objectives',
        fieldSet: 'overview'
      },
      pinnedItems: {
        type: 'linkedTable',
        entityTypeName: 'Pin',
        recommended: false,
        description: 'Setup pins to show on the home page of this {{PERSON}}',
        label: 'Pinned Items',
        fieldSet: 'admin'
      },
      challengeExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "Challenge Expertise",
        entityTypeName: 'ChallengeExpertise',
        fieldSet: 'expertise',
        description: 'Identify the levels of {{CHALLENGE}} expertise and interest this {{PERSON}} has here.'
      },
      keyIssueExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "Key Issue Expertise",
        entityTypeName: 'KeyIssueExpertise',
        fieldSet: 'expertise',
        description: 'Identify the levels of {{KEY_ISSUE}} expertise and interest this {{PERSON}} has here.'
      },
      trendExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "Trend Expertise",
        entityTypeName: 'TrendExpertise',
        fieldSet: 'expertise',
        description: 'Identify the levels of {{TREND}} expertise and interest this {{PERSON}} has here.'
      },
      topicExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "Topic Expertise",
        entityTypeName: 'TopicExpertise',
        fieldSet: 'expertise',
        description: 'Identify the levels of {{TOPIC}} expertise and interest this {{PERSON}} has here.'
      },
      subTopicExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "Sub Topic Expertise",
        entityTypeName: 'SubTopicExpertise',
        fieldSet: 'expertise',
        description: 'Identify the levels of {{SUB_TOPIC}} expertise and interest this {{PERSON}} has here.'
      },
      sdgExpertise: {
        type: 'linkedTable',
        isMulti: true,
        label: "SDG Expertise",
        entityTypeName: 'SdgExpertise',
        fieldSet: 'expertise',
        description: 'Identify the levels of {{SDG}} expertise and interest this {{PERSON}} has here.'
      },
      positions: {
        type: 'linkedTable',
        label: "{{ORGANISATIONS}}",
        entityTypeName: 'OrganisationPosition',
        fieldSet: 'roles',
        description: 'Does this {{PERSON}} hold any {{POSITIONS}} in one or more {{ORGANISATIONS}}?'
      },
      offeringTypes: {
        type: 'linkedMultiple',
        entityTypeName: 'OfferingType',
        fieldSet: 'overview'
      },
      locations: {
        type: 'linkedMultiple',
        description: 'Where is this Person primarily located?',
        entityTypeName: 'Location',
        fieldSet: 'places'
      },
      states: {
        type: 'linkedMultiple',
        recommended: false,
        description: 'Alternatively, is this Person located in any specifc or other geographic States?',
        entityTypeName: 'State',
        fieldSet: 'places'
      },
      economies: {
        type: 'linkedMultiple',
        recommended: false,
        description: 'Alternatively, is this Person located in any specific or other Countries?',
        entityTypeName: 'Economy',
        fieldSet: 'places'
      },
      email: {
        type: 'email',
        focus: true,
        fieldSet: 'contact'
      },
      hideEmail: {
        type: 'boolean',
        description: "Hide email address from other members",
        focus: true,
        fieldSet: 'contact',
        isVisible: function () {
          return (0, current_user_can_1.currentUserCanAdmin)();
        }
      },
      websiteUrl: {
        type: 'url',
        maxWidth: '800px',
        fieldSet: 'contact'
      },
      phone: {
        type: 'text',
        maxWidth: '200px',
        fieldSet: 'contact',
        description: 'Enter the phone number for this {{PERSON}} (mobile preferred) in international format e.g. +61400000000.'
      },
      hidePhone: {
        type: 'boolean',
        description: "Hide phone number from other members",
        focus: true,
        fieldSet: 'contact',
        isVisible: function () {
          return (0, current_user_can_1.currentUserCanAdmin)();
        }
      },
      facebook: {
        type: 'text',
        maxWidth: '550px',
        fieldSet: 'contact',
        placeholder: 'https://facebook.com/name',
        description: 'What is the public URL of the Facebook profile of this {{PERSON}}?'
      },
      twitter: {
        type: 'text',
        label: "X",
        maxWidth: '550px',
        fieldSet: 'contact',
        placeholder: 'https://x.com/handle',
        description: 'What is the public URL of the X (formerly Twitter) profile of this {{PERSON}}?'
      },
      threads: {
        type: 'text',
        maxWidth: '550px',
        fieldSet: 'contact',
        placeholder: 'https://www.threads.net/@handle',
        description: 'What is the URL of the Threads profile of this {{PERSON}}?'
      },
      linkedin: {
        type: 'text',
        maxWidth: '550px',
        fieldSet: 'contact',
        label: 'LinkedIn',
        placeholder: 'https://www.linkedin.com/in/first.last',
        description: 'What is the public URL of the LinkedIn profile of this {{PERSON}}?'
      },
      /* --- Privacy ---- */
      /*
      We won't allow people to manually unverify THEMSELVES, but an admin can do this
      So we check on the entityTypeName.
      */
      agreesToSharePersonalInfo: {
        type: 'boolean',
        fieldSet: 'admin',
        description: 'Does this {{PERSON}} agree to share their personal contact info (email, phone number) with other active {{USERS}} of the platform?'
      },
      /* ---- Following Admin ----- */
      followingChallenges: {
        type: 'linkedMultiple',
        description: 'Which {{CHALLENGES}} is this {{PERSON}} Following?',
        label: 'Following {{CHALLENGES}}',
        entityTypeName: 'Challenge',
        fieldSet: 'admin'
      },
      followingTopics: {
        type: 'linkedMultiple',
        description: 'Which {{TOPICS}} is this {{PERSON}} Following?',
        label: 'Following {{TOPICS}}',
        entityTypeName: 'Topic',
        fieldSet: 'admin'
      },
      followingSubTopics: {
        type: 'linkedMultiple',
        description: 'Which {{SUB_TOPICS}} is this {{PERSON}} Following?',
        label: 'Following {{SUB_TOPICS}}',
        entityTypeName: 'SubTopic',
        fieldSet: 'admin'
      },
      followingTrends: {
        type: 'linkedMultiple',
        description: 'Which {{TRENDS}} is this {{PERSON}} Following?',
        label: 'Following {{TRENDS}}',
        entityTypeName: 'Trend',
        fieldSet: 'admin'
      },
      followingChapters: {
        type: 'linkedMultiple',
        description: 'Which {{CHAPTERS}} is this {{PERSON}} Following?',
        label: 'Following {{CHAPTERS}}',
        entityTypeName: 'Chapter',
        fieldSet: 'admin'
      },
      followingTeams: {
        type: 'linkedMultiple',
        description: 'Which {{TEAMS}} is this {{PERSON}} Following?',
        label: 'Following {{TEAMS}}',
        entityTypeName: 'Team',
        fieldSet: 'admin'
      },
      followingCourses: {
        isVisible: function (_a) {
          var entities = _a.entities;
          return !!entities.Course;
        },
        type: 'linkedMultiple',
        description: 'Which {{COURSES}} is this {{PERSON}} Following?',
        label: 'Following {{COURSES}}',
        entityTypeName: 'Course',
        fieldSet: 'admin'
      },
      followingEconomies: {
        type: 'linkedMultiple',
        description: 'Which {{ECONOMIES}} is this {{PERSON}} Following?',
        label: 'Following {{ECONOMIES}}',
        entityTypeName: 'Economy',
        fieldSet: 'admin'
      },
      followingEvents: {
        type: 'linkedMultiple',
        description: 'Which {{EVENTS}} is this {{PERSON}} Following?',
        label: 'Following {{EVENTS}}',
        entityTypeName: 'Event',
        fieldSet: 'admin'
      },
      followingFeedEntries: {
        type: 'linkedMultiple',
        description: 'Which {{FEED_ENTRIES}} is this {{PERSON}} Following?',
        label: 'Following {{FEED_ENTRIES}}',
        entityTypeName: 'FeedEntry',
        fieldSet: 'admin'
      },
      followingImpactStories: {
        type: 'linkedMultiple',
        description: 'Which {{IMPACT_STORIES}} is this {{PERSON}} Following?',
        label: 'Following {{IMPACT_STORIES}}',
        entityTypeName: 'ImpactStory',
        fieldSet: 'admin'
      },
      followingKeyIssues: {
        type: 'linkedMultiple',
        description: 'Which {{KEY_ISSUES}} is this {{PERSON}} Following?',
        label: 'Following {{KEY_ISSUES}}',
        entityTypeName: 'KeyIssue',
        fieldSet: 'admin'
      },
      followingLessons: {
        isVisible: function (_a) {
          var entities = _a.entities,
            currentUserCan = _a.currentUserCan;
          return !!entities.Lesson;
        },
        type: 'linkedMultiple',
        description: 'Which {{LESSONS}} is this {{PERSON}} Following?',
        label: 'Following {{LESSONS}}',
        entityTypeName: 'Lesson',
        fieldSet: 'admin'
      },
      followingLocations: {
        type: 'linkedMultiple',
        description: 'Which {{LOCATIONS}} is this {{PERSON}} Following?',
        label: 'Following {{LOCATIONS}}',
        entityTypeName: 'Location',
        fieldSet: 'admin'
      },
      followingOrganisations: {
        type: 'linkedMultiple',
        description: 'Which {{ORGANISATIONS}} is this {{PERSON}} Following?',
        label: 'Following {{ORGANISATIONS}}',
        entityTypeName: 'Organisation',
        fieldSet: 'admin'
      },
      followingPages: {
        type: 'linkedMultiple',
        description: 'Which {{PAGES}} is this {{PERSON}} Following?',
        label: 'Following {{PAGES}}',
        entityTypeName: 'Page',
        fieldSet: 'admin'
      },
      followingPeople: {
        type: 'linkedMultiple',
        description: 'Which {{PEOPLE}} is this {{PERSON}} Following?',
        label: 'Following {{PEOPLE}}',
        entityTypeName: 'Person',
        fieldSet: 'admin'
      },
      followingProducts: {
        isVisible: function (_a) {
          var entities = _a.entities;
          return !!entities.Product;
        },
        type: 'linkedMultiple',
        description: 'Which {{PRODUCTS}} is this {{PERSON}} Following?',
        label: 'Following {{PRODUCTS}}',
        entityTypeName: 'Product',
        fieldSet: 'admin'
      },
      // followingSessions: { type: 'linkedMultiple', description: 'Which {{SESSIONS}} is this {{PERSON}} Following?', label: 'Following {{SESSIONS}}', entityTypeName: 'Session', fieldSet: 'admin' },
      followingWorkstreams: {
        type: 'linkedMultiple',
        description: 'Which {{WORKSTREAMS}} is this {{PERSON}} Following?',
        label: 'Following {{WORKSTREAMS}}',
        entityTypeName: 'Workstream',
        fieldSet: 'admin'
      },
      profileCompletionDate: {
        type: 'date',
        fieldSet: 'admin',
        description: 'When was the profile for this {{PERSON}} completed?'
      }
    }
  },
  update: {
    // todo - need to fix this, when there is a linked item with fields that need more than just entity value, tables etc fail to have enough info.
    queryFields: (0, graphql_1.graphql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      pinnedItems { item { entity { ...EntityValueFields } } }\n    "], ["\n      pinnedItems { item { entity { ...EntityValueFields } } }\n    "]))),
    onComplete: function (result_1, _a) {
      return __awaiter(void 0, [result_1, _a], void 0, function (result, _b) {
        var _c, state, setState;
        var appState = _b.appState;
        return __generator(this, function (_d) {
          _c = __read(appState, 2), state = _c[0], setState = _c[1];
          setState(__assign(__assign({}, state), {
            activePerson: null
          }));
          return [2 /*return*/];
        });
      });
    }
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      id name linkedin twitter phone email facebook position\n      quotes { ...EntityValueFields person { ...EntityValueFields } }\n      role { id name }\n      bio { id text }\n      platformObjective { id text }\n      feedEntries { id }\n      agreesToSharePersonalInfo\n      agreesToTerms\n      colleagues { ...EntityValueFields position }\n      videos { ...EntityValueFields url }\n      moderating { ...EntityValueFields }\n      courseRegistrations {\n        ...EntityValueFields\n        course { \n          badge\n          isCurrentUserCertified\n          ...EntityValueFields\n        }\n      }\n      challengeExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        challenges { ...EntityValueFields }\n      }\n      keyIssueExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        keyIssues { ...EntityValueFields }\n      }\n      topicExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        topics { ...EntityValueFields }\n      }\n      subTopicExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        subTopics { ...EntityValueFields }\n      }\n      trendExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        trends { ...EntityValueFields }\n      }\n      sdgExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        sdgs { ...EntityValueFields color { ...EntityValueFields} }\n      }\n      pages { ...EntityValueFields }\n      teams { ...EntityValueFields type { id name slug } }\n      posts { ...EntityValueFields }\n      locations { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      organisation { ...EntityValueFields }\n      chapterRoles { id chapter { ...EntityValueFields } role { ...EntityValueFields } }\n      positions { id primary position organisation { ...EntityValueFields type { id name slug } } }\n      photo { id url width height aspectRatio }\n      teamRoles { ...EntityValueFields role { id name slug } team { ...EntityValueFields } }\n      pinnedItems { \n        id \n        item {\n          entity {\n            id name slug\n            openGraph { \n              id\n              image { id url }\n            }\n          }\n        }\n      }\n    "], ["\n      id name linkedin twitter phone email facebook position\n      quotes { ...EntityValueFields person { ...EntityValueFields } }\n      role { id name }\n      bio { id text }\n      platformObjective { id text }\n      feedEntries { id }\n      agreesToSharePersonalInfo\n      agreesToTerms\n      colleagues { ...EntityValueFields position }\n      videos { ...EntityValueFields url }\n      moderating { ...EntityValueFields }\n      courseRegistrations {\n        ...EntityValueFields\n        course { \n          badge\n          isCurrentUserCertified\n          ...EntityValueFields\n        }\n      }\n      challengeExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        challenges { ...EntityValueFields }\n      }\n      keyIssueExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        keyIssues { ...EntityValueFields }\n      }\n      topicExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        topics { ...EntityValueFields }\n      }\n      subTopicExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        subTopics { ...EntityValueFields }\n      }\n      trendExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        trends { ...EntityValueFields }\n      }\n      sdgExpertise {\n        badge\n        levelOfExpertise { ...EntityValueFields orderNumber description { id text } }\n        sdgs { ...EntityValueFields color { ...EntityValueFields} }\n      }\n      pages { ...EntityValueFields }\n      teams { ...EntityValueFields type { id name slug } }\n      posts { ...EntityValueFields }\n      locations { ...EntityValueFields }\n      economies { ...EntityValueFields }\n      organisation { ...EntityValueFields }\n      chapterRoles { id chapter { ...EntityValueFields } role { ...EntityValueFields } }\n      positions { id primary position organisation { ...EntityValueFields type { id name slug } } }\n      photo { id url width height aspectRatio }\n      teamRoles { ...EntityValueFields role { id name slug } team { ...EntityValueFields } }\n      pinnedItems { \n        id \n        item {\n          entity {\n            id name slug\n            openGraph { \n              id\n              image { id url }\n            }\n          }\n        }\n      }\n    "])))
  }
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;